"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwSnap = void 0;
const CademyError_1 = __importDefault(require("../CademyError"));
class AwSnap extends CademyError_1.default {
    constructor(detail) {
        super('generic/aw-snap', 'Something Went Wrong', detail, 500);
    }
}
exports.AwSnap = AwSnap;
exports.default = AwSnap;
